import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import footerImg from '../../assets/img/common/banner-footer.png'

import banner from '../../assets/img/home/banner.jpg'
import unImg from '../../assets/img/home/un.png'
import ukImg from '../../assets/img/home/uk.png'
import usImg from '../../assets/img/home/us.png'
import caImg from '../../assets/img/home/ca.png'
import ruImg from '../../assets/img/home/ru.png'
import frImg from '../../assets/img/home/fr.png'
import geImg from '../../assets/img/home/ge.png'
import plImg from '../../assets/img/home/polish.png'
import trImg from '../../assets/img/home/turkish.png'
import singaporeanImg from '../../assets/img/home/singaporean.png'
import indianImg from '../../assets/img/home/indian.png'
import austrianImg from '../../assets/img/home/austrian.png'
import newzealandImg from '../../assets/img/home/newzealand.png'
import southafricanImg from '../../assets/img/home/southafrican.png'
import pakistaniImg from '../../assets/img/home/pakistani.png'
import malaysianImg from '../../assets/img/home/malaysian.png'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Tooltip, message } from 'antd';
import './index.css'
import '../../assets/css/common.css'

class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			citationCH: '武汉大学信息检索与知识挖掘研究所. 议会大数据平台 (PBDP).http://parliament.whu.edu.cn.',
			citationEN: 'Information Retrieval and Knowledge Mining Laboratory of Wuhan University. Parliamentary Big Data Platform (PBDP) .http://parliament.whu.edu.cn.',
			copied: false,	
		}
	}

	handleClick = () => {
		message.success('复制成功')
	}

	handleCopy = () => {
		this.setState({copied: true})
	}

	render() {
		const { citationCH, citationEN } = this.state;
		return (
			<div>
				<div style={{ backgroundImage: `url(${banner})`, backgroundRepeat: 'no-repeat', backgroundSize: 'auto 135px', padding: '10px 15%', height: 135 }}>
					<div className="major-heading" style={{ color: '#FFFFFF', fontSize: 20}}>议会大数据平台</div>
					<div className="auxiliary-text" style={{ color: 'rgba(255, 255, 255, 0.48)' }}>PARLIAMENT BIG DATA</div>
					<div className="main-text" style={{ color: 'rgba(255, 255, 255, 0.88)', marginTop: 10, textIndent: '2em', width: '96%', }}>
					集成了议会制国家议会及议员的相关会议内容，提供内容浏览、检索、下载以及知识关联、深度挖掘等功能，有助于研究议会制国家的国际关系发展态势，对改善国家对外关系和制定外交政策具有重要作用。
					</div>
				</div>
				<div className="module db-block" style={{marginBottom: 0 }}>
					 <div className="main-title">西方主要国家</div> 
				</div>
				<div className="module db-block padd-left">
					<div className="title major-heading">议会数据库</div>
					<div className="subtitle auxiliary-text">DATABASE FOR PARLIAMENT</div>
					<Link to={`/database/parl/us`}>
						<div className="block"> 
							<img alt="" className="country-img" src={usImg}/>
							<div className="country-title minor-heading">美国</div>
							<div className="country-subtitle main-text">议会 (1995-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/uk`}>
						<div className="block">
							<img alt="" className="country-img" src={ukImg}/>
							<div className="country-title minor-heading">英国</div>
							<div className="country-subtitle main-text" >议会 (1935-)</div>
						</div>
					</Link>
					{/* database/senator/ru    */}
					<Link to={`/database/parl/ru`}> 
						<div className="block" > 
							<img alt="" className="country-img" src={ruImg}/>
							<div className="country-title minor-heading">俄罗斯</div>
							<div className="country-subtitle main-text">议会 (1997-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/eu`}>
						<div className="block" > 
							<img alt="" className="country-img" src={unImg}/>
							<div className="country-title minor-heading">欧洲</div>
							<div className="country-subtitle main-text">议会 (1949-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/fr`}>
						<div className="block" > 
							<img alt="" className="country-img" src={frImg}/>
							<div className="country-title minor-heading">法国</div>
							<div className="country-subtitle main-text">议会 (1958-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/ge`}>
						<div className="block" > 
							<img alt="" className="country-img" src={geImg}/>
							<div className="country-title minor-heading">德国</div>
							<div className="country-subtitle main-text">议会 (1949-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/ca`}>
						<div className="block"> 
							<img alt="" className="country-img" src={caImg}/>
							<div className="country-title minor-heading">加拿大</div>
							<div className="country-subtitle main-text">议会 (1901-)</div>
						</div>
					</Link>
				</div>

				<div className="module db-block padd-left">
					<div className="title major-heading ">议员数据库</div>
					<div className="subtitle auxiliary-text ">DATABASES FOR SENATORS</div>
					<Link to={`/database/senator/us`}>
						<div className="block">
							<img alt="" className="country-img" src={usImg} />
							<div className="country-title minor-heading">美国</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/uk`}>
						<div className="block">
							<img alt="" className="country-img" src={ukImg} />
							<div className="country-title minor-heading">英国</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					{/* database/senator/ru    */}
					<Link to={`/database/senator/ru`}>  
						<div className="block">
							<img alt="" className="country-img" src={ruImg} />
							<div className="country-title minor-heading">俄罗斯</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/eu`}>
						<div className="block">
							<img alt="" className="country-img" src={unImg} />
							<div className="country-title minor-heading">欧洲</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/fr`}>
						<div className="block">
							<img alt="" className="country-img" src={frImg}  />
							<div className="country-title minor-heading">法国</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/ge`}>
						<div className="block">
							<img alt="" className="country-img" src={geImg}  />
							<div className="country-title minor-heading">德国</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/ca`}>
						<div className="block">
							<img alt="" className="country-img" src={caImg} />
							<div className="country-title minor-heading">加拿大</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
				</div>
				
				<div className="module db-block" style={{marginBottom: 0,marginTop: 20}}>
					 <div className="main-title">一带一路专栏</div> 
				</div>
				<div className="module db-block padd-left">
					<div className="title major-heading ">议会数据库</div>
					<div className="subtitle auxiliary-text ">DATABASE FOR PARLIAMENT</div>
					<Link to={`/database/parl/pk`}>
						<div className="block"> 
							<img alt="" className="country-img" src={pakistaniImg}/>
							<div className="country-title minor-heading">巴基斯坦</div>
							<div className="country-subtitle main-text">议会 (1947-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/my`}>
						<div className="block"> 
							<img alt="" className="country-img" src={malaysianImg}/>
							<div className="country-title minor-heading">马来西亚</div>
							<div className="country-subtitle main-text">议会 (1959-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/sg`}>
						<div className="block"> 
							<img alt="" className="country-img" src={singaporeanImg}/>
							<div className="country-title minor-heading">新加坡</div>
							<div className="country-subtitle main-text">议会 (1955-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/tr`}>
						<div className="block"> 
							<img alt="" className="country-img" src={trImg}/>
							<div className="country-title minor-heading">土耳其</div>
							<div className="country-subtitle main-text">议会 (1996-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/nz`}>
						<div className="block"> 
							<img alt="" className="country-img" src={newzealandImg}/>
							<div className="country-title minor-heading">新西兰</div>
							<div className="country-subtitle main-text">议会 (2002-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/india`}>
						<div className="block"> 
							<img alt="" className="country-img" src={indianImg}/>
							<div className="country-title minor-heading">印度</div>
							<div className="country-subtitle main-text">议会 (2000-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/pl`}>
						<div className="block"> 
							<img alt="" className="country-img" src={plImg}/>
							<div className="country-title minor-heading">波兰</div>
							<div className="country-subtitle main-text">议会 (2019-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/za`}>
						<div className="block"> 
							<img alt="" className="country-img" src={southafricanImg}/>
							<div className="country-title minor-heading">南非</div>
							<div className="country-subtitle main-text">议会 (1999-)</div>
						</div>
					</Link>
					<Link to={`/database/parl/at`}>
						<div className="block">
							<img alt="" className="country-img" src={austrianImg}/>
							<div className="country-title minor-heading">奥地利</div>
							<div className="country-subtitle main-text">议会 (1918-)</div>
						</div>
					</Link>
				</div>
				<div className="module db-block padd-left">
					<div className="title major-heading ">议员数据库</div>
					<div className="subtitle auxiliary-text ">DATABASES FOR SENATORS</div>
					<Link to={`/database/senator/pk`}>
						<div className="block"> 
							<img alt="" className="country-img" src={pakistaniImg}/>
							<div className="country-title minor-heading">巴基斯坦</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/my`}>
						<div className="block"> 
							<img alt="" className="country-img" src={malaysianImg}/>
							<div className="country-title minor-heading">马来西亚</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/sg`}>
						<div className="block"> 
							<img alt="" className="country-img" src={singaporeanImg}/>
							<div className="country-title minor-heading">新加坡</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/tr`}>
						<div className="block">
							<img alt="" className="country-img" src={trImg} />
							<div className="country-title minor-heading">土耳其</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/nz`}>
						<div className="block"> 
							<img alt="" className="country-img" src={newzealandImg}/>
							<div className="country-title minor-heading">新西兰</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/india`}>
						<div className="block"> 
							<img alt="" className="country-img" src={indianImg}/>
							<div className="country-title minor-heading">印度</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/pl`}>
						<div className="block">
							<img alt="" className="country-img" src={plImg} />
							<div className="country-title minor-heading">波兰</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/za`}>
						<div className="block"> 
							<img alt="" className="country-img" src={southafricanImg}/>
							<div className="country-title minor-heading">南非</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
					<Link to={`/database/senator/at`}>
						<div className="block"> 
							<img alt="" className="country-img" src={austrianImg}/>
							<div className="country-title minor-heading">奥地利</div>
							<div className="country-subtitle main-text">议员</div>
						</div>
					</Link>
				</div>
				<div className="module">
					<div className="title major-heading">引用说明</div>
					<div className="subtitle auxiliary-text">FOR REFERENCE</div>
					<div className="cite-text main-text" onClick={this.handleClick}>
						<Tooltip title="单击文本即可复制">
							<CopyToClipboard text={this.state.citationCH} onCopy={this.handleCopy}>
								<span>{citationCH}</span>
							</CopyToClipboard>
						</Tooltip>
					</div>
					<div className="cite-text main-text" onClick={this.handleClick}>
						<Tooltip title="单击文本即可复制">
							<CopyToClipboard text={this.state.citationEN} onCopy={this.handleCopy}>
								<span>{citationEN}</span>
							</CopyToClipboard>
						</Tooltip>
					</div>
				</div>
			</div>
		);
	}
}

export default Home
